import { AppContext } from "@/App";
import { useContext } from "react";
import { useResponsiveZoom } from "@/hooks/use-responsive-zoom";

const TaskBar = () => {
const app = useContext(AppContext);
const zoomLevel = useResponsiveZoom();

  return (
    <div className='flex flex-row justify-between px-4 fixed inset-x-0 bottom-0 border-t-2 bg-taskbar-background text-taskbar-foreground z-10' style={{ zoom: zoomLevel }}>
        <div className="w-[30%]">app ver 1.0.20260126</div>
        <div className="">{app.applicationUser?.role}: {app.applicationUser?.name}
            {app.applicationUser?.role !== 'Admin' 
                ? " - " + app.projectRole
                : null} 
           </div>
        <div className="w-[30%] h-6 text-end">{app.taskbarMessage}</div>
    </div>
  )
}

export default TaskBar